// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "tachographs div.frame {\n  overflow: auto;\n  border: 1px solid #a9a9a9;\n}\ntachographs .container-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto max-content;\n  height: 100vh;\n}", ""]);
// Exports
module.exports = exports;
